import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';
import AuthLayout from './AuthLayout';
import { initiateCloverAuth } from '../../redux/slices/cloverSlice';
import { fadeIn, fadeInUp } from '../../utils/animations';
import ENDPOINTS from '../../api/endPoints';

/**
 * CloverIntegration - Dedicated page for Clover OAuth flow
 * Automatically redirects to Clover OAuth on page load
 */
const CloverIntegration: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Automatically dispatch action to redirect to Clover OAuth when this page loads
    // dispatch(initiateCloverAuth());
  }, [dispatch]);

  const handleManualRedirect = () => {
    dispatch(initiateCloverAuth());
  };

    const handleCloverLogin = () => {
    window.location.href = ENDPOINTS.cloverOauth;
  };

  return (
     <AuthLayout
      title="All your campaigns,"
      subtitle="Starting with one idea."
    >
      <style>{`
        @keyframes rotate-border {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        
        .animated-border-card {
          position: relative;
          border-radius: 1rem;
          padding: 1px;
          background: linear-gradient(90deg,hsl(10, 75.90%, 88.60%),rgb(239, 182, 171),rgb(223, 72, 42), #EC4523);
          background-size: 300% 300%;
          animation: gradient-shift 3s ease infinite;
        }
        
        @keyframes gradient-shift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        
        .animated-border-card::before {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 1rem;
          padding: 2px;
          // background: linear-gradient(90deg,rgb(251, 135, 112), #EC4523,);
          background-size: 200% 200%;
          animation: rotate-gradient 4s linear infinite;
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          z-index: -1;
        }
        
        @keyframes rotate-gradient {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 200% 50%;
          }
        }
        
        .card-inner {
          background: rgba(17, 17, 17, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 0.95rem;
          position: relative;
          z-index: 1;
        }
      `}</style>
      <div className="w-full max-w-md h-full flex items-center justify-center">
        <div className="animated-border-card shadow-2xl" style={{ width: '100%' }}>
          <div className="card-inner p-8">
            <motion.div
              variants={fadeIn}
              initial="hidden"
              animate="visible"
              className="text-center"
            >
            {/* Clover Logo/Icon */}
            {/* <div className="mb-6 flex justify-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center">
                <svg 
                  className="w-12 h-12 text-white" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
            </div> */}

            {/* Title */}
            <h2 className="text-white text-2xl font-semibold mb-3">
              Connect with POS
            </h2>

            {/* Description */}
            <p className="text-gray-400 text-sm mb-6">
              Authorize Clover to sync your menu and restaurant data.
            </p>

            <motion.div className="flex justify-center py-3" variants={fadeInUp}>
              <button
                type="button"
                onClick={handleCloverLogin}
                className=" focus:outline-none"
                title="Connect with Clover"
              >
                <img 
                  src="https://cloverstatic.com/web/apps/web-global-developer/release_gde_10282025_2-18913a3f1446e/assets/images/clover-logo-public.svg" 
                  alt="Clover Logo" 
                  className="h-10 w-auto cursor-pointer"
                />
              </button>
            </motion.div>


            {/* Loading Spinner */}
            {/* <div className="flex justify-center items-center gap-3 mb-6">
              <div className="relative">
                <div className="w-12 h-12 border-4 border-gray-700 rounded-full"></div>
                <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
              </div>
              <span className="text-gray-400 text-sm">Redirecting to Clover...</span>
            </div> */}

            {/* Divider */}
            {/* <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-4"></div> */}

            {/* Info Text */}
            {/* <p className="text-gray-500 text-xs">
              If you're not redirected automatically,{' '}
              <button
                onClick={handleManualRedirect}
                className="text-green-500 hover:text-green-400 underline transition-colors"
              >
                click here
              </button>
            </p> */}
            </motion.div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default React.memo(CloverIntegration);
